export const displaySSR = ["WCHC","WCHR","UMNR","BLND","DEAF","ESAN","VIP","WCHS"]